











































import { VozidloPujcovna } from '@/modules/pujcovna/vozidloPujcovna';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { PredmetPujcovna } from '@/modules/pujcovna/ostatniPredmety';

import { PredmetZapujckyEnum } from '../constants';
import { editActions, editMutations } from '../store/types';
import { store } from '../store/edit';
import Buttons from './Buttons.vue';
import ZapujckaZakaznikSelect from './microcomponents/ZakaznikSelect.vue';

export default PageModeMixin.extend({
	name: 'EditHeader',
	data() {
		return {
			predmetZapujckySelect: [
				{ Value: 0, Text: this.LocalizePopisostatni('Vozidlo') },
				{ Value: 1, Text: this.LocalizePopisostatni('Predmet') },
			],
			PredmetZapujckyEnum,
		};
	},
	components: {
		PredmetPujcovnaSelect: PredmetPujcovna.components.Select,
		VozidloPujcovnaSelect: VozidloPujcovna.components.Select,
		ZapujckaZakaznikSelect,
		Buttons,
	},
	props: {
		storeUri: String,
		zapujckaStav: Object,
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers() : Record<string, string> {
			return {
				vozidloPujcovna: `${this.storeUri}/${editMutations.ZAPUJCKA_VOZIDLO_PUJCOVNA_SELECT_MAPPER}`,
				predmetPujcovna: `${this.storeUri}/${editMutations.ZAPUJCKA_PREDMET_PUJCOVNA_SELECT_MAPPER}`,
			};
		},
		actions() : Record<string, string> {
			return {
				vozidloChange: `${this.storeUri}/${editActions.VOZIDLO_CHANGE}`,
				predmetChange: `${this.storeUri}/${editActions.PREDMET_CHANGE}`,
			};
		},
		predmetPujcovnaFilter(): object {
			return {
				PujcovnaId: this.PujcovnaId,
				SkladostOzn: this.Skladost,
				OstatniNr: this.OstatnipaNr,
			};
		},
		vozidloFilter(): object {
			return {
				PujcenePrp: false,
				PreslimitPrp: false,
				VyrazenePrp: false,
				Externivoz: true,
				Vlastnivoz: true,
			};
		},
		isPujcovnaDisabled(): boolean {
			return !!(this.VozidlopaId || this.OstatnipaId);
		},
		isVozidloZakaznikDisabled(): boolean {
			return !(this.zapujckaStav.isOtevrena && !this.RozsirProtokol) || this.isViewMode;
		},
		isOstatnipaDisabled(): boolean {
			return !(this.zapujckaStav.isOtevrena && !this.RozsirProtokol);
		},
		isPredmetSelectVisible():boolean {
			return this.selectedPredmetZapujcky === PredmetZapujckyEnum.PREDMET;
		},
	},
	methods: {
		savePujcpa(goBack: boolean) {
			this.$emit('savePujcpa', goBack);
		},
		loadedData() {
			if (this.OstatnipaId) {
				this.selectedPredmetZapujcky = PredmetZapujckyEnum.PREDMET;
			} else {
				this.selectedPredmetZapujcky = PredmetZapujckyEnum.VOZIDLO;
			}
		},
	},
});
